module.exports = __webpack_public_path__ + "img/verified.f9735b06.svg";